/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialogue_List_Export_Trial_TextInputs */

const en_dialogue_list_export_trial_text = /** @type {(inputs: Dialogue_List_Export_Trial_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thank you for trying Closed Caption Creator. Your subscription is currently running in Trial Mode. All exports will contain the word TRIAL. Would you like to activate your account in order to remove this restriction?`)
};

const fr_dialogue_list_export_trial_text = /** @type {(inputs: Dialogue_List_Export_Trial_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Merci d'essayer Closed Caption Creator. Votre abonnement est actuellement en mode d'essai. Toutes les exportations contiendront le mot TRIAL. Souhaitez-vous activer votre compte pour supprimer cette restriction ?`)
};

const de_dialogue_list_export_trial_text = /** @type {(inputs: Dialogue_List_Export_Trial_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vielen Dank, dass Sie Closed Caption Creator ausprobiert haben. Ihr Abonnement befindet sich derzeit im Testmodus. Alle Exporte enthalten den Hinweis „TESTVERSION“. Möchten Sie Ihr Konto aktivieren, um diese Einschränkung aufzuheben?`)
};

const it_dialogue_list_export_trial_text = /** @type {(inputs: Dialogue_List_Export_Trial_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grazie per aver provato Closed Caption Creator. Il tuo abbonamento è attualmente in modalità di prova. Tutte le esportazioni conterranno la parola "PROVA". Desideri attivare il tuo account per rimuovere questa restrizione?`)
};

const ru_dialogue_list_export_trial_text = /** @type {(inputs: Dialogue_List_Export_Trial_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Спасибо за использование Closed Caption Creator. Ваша подписка в настоящее время находится в пробном режиме. Все экспортированные файлы будут содержать слово TRIAL. Хотите ли вы активировать свою учетную запись, чтобы снять это ограничение?`)
};

const es_dialogue_list_export_trial_text = /** @type {(inputs: Dialogue_List_Export_Trial_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gracias por probar el Creador de Subtítulos. Su suscripción está actualmente en modo de prueba. Todas las exportaciones contendrán la palabra PRUEBA. ¿Desea activar su cuenta para eliminar esta restricción?`)
};

const zh_cn2_dialogue_list_export_trial_text = /** @type {(inputs: Dialogue_List_Export_Trial_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`感谢您试用字幕创建器。您的订阅目前处于试用模式。所有导出的文件都会包含“试用”字样。您是否想激活您的帐户以解除此限制？`)
};

const ja_dialogue_list_export_trial_text = /** @type {(inputs: Dialogue_List_Export_Trial_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Closed Caption Creator をお試しいただきありがとうございます。現在、お客様のサブスクリプションはトライアルモードです。すべてのエクスポートには「TRIAL」という単語が含まれます。この制限を解除するには、アカウントを有効化しますか？`)
};

const hi_dialogue_list_export_trial_text = /** @type {(inputs: Dialogue_List_Export_Trial_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`क्लोज्ड कैप्शन क्रिएटर को आज़माने के लिए धन्यवाद। आपकी सदस्यता वर्तमान में ट्रायल मोड में है। सभी निर्यात फ़ाइलों में "ट्रायल" शब्द दिखाई देगा। क्या आप इस प्रतिबंध को हटाने के लिए अपना खाता सक्रिय करना चाहेंगे?`)
};

const pt_pt2_dialogue_list_export_trial_text = /** @type {(inputs: Dialogue_List_Export_Trial_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obrigado por experimentar o Closed Caption Creator. Sua assinatura está atualmente em Modo de Avaliação. Todas as exportações conterão a palavra "AVALIAÇÃO". Deseja ativar sua conta para remover essa restrição?`)
};

/**
* | output |
* | --- |
* | "Thank you for trying Closed Caption Creator. Your subscription is currently running in Trial Mode. All exports will contain the word TRIAL. Would you like to..." |
*
* @param {Dialogue_List_Export_Trial_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const dialogue_list_export_trial_text = /** @type {((inputs?: Dialogue_List_Export_Trial_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialogue_List_Export_Trial_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_dialogue_list_export_trial_text(inputs)
	if (locale === "de") return de_dialogue_list_export_trial_text(inputs)
	if (locale === "it") return it_dialogue_list_export_trial_text(inputs)
	if (locale === "ru") return ru_dialogue_list_export_trial_text(inputs)
	if (locale === "es") return es_dialogue_list_export_trial_text(inputs)
	if (locale === "zh-CN") return zh_cn2_dialogue_list_export_trial_text(inputs)
	if (locale === "ja") return ja_dialogue_list_export_trial_text(inputs)
	if (locale === "hi") return hi_dialogue_list_export_trial_text(inputs)
	if (locale === "pt-PT") return pt_pt2_dialogue_list_export_trial_text(inputs)
	return en_dialogue_list_export_trial_text(inputs)
});